import { Button } from 'components/button/Button';
import styled, { css } from 'styled-components';

export const defaultButtonStyle = css`
    font-size: 1.4rem;
    font-weight: 500;
    min-width: 100px;
    padding: 14px 20px;
    background: var(--primary-default);
    color: var(--text-on-color);

    &:hover {
        background: var(--primary-dark);
    }

    &:disabled {
        color: var(--action-disabled);
        background: var(--action-disabled-background);
    }
`;

export const DefaultButton = styled(Button)`
    ${defaultButtonStyle}
`;
